// src/app/shared/store/auth/auth.guard.ts
import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthSessionService } from './auth-session.service';

export const authCanMatch: CanMatchFn = () => {
  const session = inject(AuthSessionService);
  const router = inject(Router);

  return session.getStatus() === 'guest'
    ? router.createUrlTree(['/auth/login'])
    : true;
};
